"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
    updateStore
    Utitlity function that updates app store.
*/


var updateStore = function updateStore(action, value, dispatch) {
  dispatch(_defineProperty({
    type: action
  }, action, value)); //if history state is updating the subscribeID will not update

  if (action !== 'updateHistory') {
    dispatch({
      type: 'updateSubscribeID',
      updateSubscribeID: 0
    });
  }
};

var _default = updateStore;
exports["default"] = _default;
module.exports = exports["default"];